import store from './../store'
import env from './../env'

export default {
  path: '/candidates',
  name: 'candidates',
  redirect: { name: 'candidates.list-page' },
  component: () => import('@/views/candidates/index.vue'),
  children: [
    {
      path: '/candidates',
      name: 'candidates.list-page',
      component: () => import('@/views/candidates/ListPage.vue'),
    },
    {
      path: '/candidates/in-progress',
      name: 'candidates.in-progress-page',
      component: () => import('@/views/candidates/InProgressPage.vue'),
    },
    {
      path: '/candidates/pools',
      name: 'candidates.pools-page',
      component: () => import('@/views/candidates/PoolsPage.vue'),
    },
    {
      path: '/candidates/:candidateId',
      name: 'candidates.view-candidate',
      component: () => import('@/views/candidates/ViewCandidate.vue'),
    },
  ],
  // Open to Work is one Beta feature spanning both sides — the tradie half
  // (routes/openToWork.js) is already gated off in staging/prod behind this
  // same flag while the API's own open_to_work_enabled stays on. This side
  // (business-admin candidate search + resume requests + workforce
  // invitations) wasn't gated to match, so a company could still send a
  // resume request a tradie could never open (their /open-to-work/requests
  // page 404s while the flag is off) — a dead-end notification with no way
  // to respond. Gating both sides together keeps the feature off as a whole
  // until the tradie side is ready.
  beforeEnter: async (to, from, next) => {
    if (!env.openToWorkEnabled) return next({ name: 'page-not-found' })
    if (store.state.auth.user) {
      if (store.state.auth.user.user_type !== 'business_admin')
        return next({ name: 'page-not-found' })
      return next()
    }
    store
      .dispatch('auth/getAuthenticatedUser')
      .then(() => {
        if (store.state.auth.user.user_type !== 'business_admin')
          next({ name: 'page-not-found' })
        else next()
      })
      .catch(() => next({ name: 'auth.login-page' }))
  },
}
